// extracted by mini-css-extract-plugin
export default {"bottomNavWrapper":"bottomNav_bottomNavWrapper__jB50f"};